import I18n from 'I18n';
import UsersAndTeamsAssetAccessPanelWithDataFetching from 'ui-asset-management-lib/components/UsersAndTeamsAssetAccessPanelWithDataFetching';
import useManageAccessPanel from 'asset-actions-lib/hooks/useManageAccessPanel';
import { getPropertyValue } from 'asset-actions-lib/utils/crmObject';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ManageAccessPanel({
  onClose,
  onConfirm,
  crmObject
}) {
  const objectId = getPropertyValue(crmObject, 'hs_object_id');
  const {
    objectTypeId
  } = crmObject;
  const {
    teamIds,
    userIds,
    hasErrors,
    isLoading,
    handleSave
  } = useManageAccessPanel({
    objectId: objectId ? parseInt(objectId, 10) : 0,
    objectTypeId,
    onConfirm,
    crmObject
  });
  return /*#__PURE__*/_jsx(UsersAndTeamsAssetAccessPanelWithDataFetching, {
    assetTypeDisplayName: I18n.text(`assetActionsLib.objectTypeNames.${objectTypeId}.singularUppercase`),
    assignedTeamIds: teamIds,
    assignedUserIds: userIds,
    requestsError: hasErrors,
    requestsLoading: isLoading && !hasErrors,
    onCancel: onClose,
    onSave: handleSave
  });
}